module.exports = __webpack_public_path__ + "images/27eacd81e8737d813cd9c6885fc3e988.png";